import { jsx, jsxs } from 'react/jsx-runtime';
import { useCallback, useMemo } from 'react';
import { Button } from '../../Button/Button.es.js';
import { Chip } from '../../Chip/Chip.es.js';
import { Icon } from '../../Icon/Icon.es.js';
import { useMenuContext } from '../Menu.Context/index.es.js';

const MenuChipButton = ({ chipVariant, chipIcon, children, variant = 'text', ...props })=>{
    const [{ inputLoading, disabled, open }, { setOpen }] = useMenuContext();
    const handleClick = useCallback(()=>{
        setOpen(!open);
    }, [
        open,
        setOpen
    ]);
    const iconName = useMemo(()=>open ? 'ChevronUpSolid' : 'ChevronDownSolid', [
        open
    ]);
    return jsx(Button, {
        className: "trigger-chip",
        disabled: disabled,
        loading: inputLoading,
        onClick: handleClick,
        variant: variant,
        ...props,
        children: jsxs(Chip, {
            className: "border-none",
            icon: chipIcon,
            variant: chipVariant,
            children: [
                children,
                jsx(Icon, {
                    name: iconName,
                    size: 16
                })
            ]
        })
    });
};
MenuChipButton.displayName = 'MenuV2.ChipButton';

export { MenuChipButton };
//# sourceMappingURL=Menu.ChipButton.es.js.map
